import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-engine/_layout/logic-components/$componentId/_layout/')({});